export const actionTypes = {
    SHOW_SWITCH_ORG_MODAL: 'switchOrganization/SHOW_SWITCH_ORG_MODAL',
};
